import $ from "jquery"
import jqueryValidation from "jquery-validation"
import jqueryValidationUnobtusive from "jquery-validation-unobtrusive"
import { dbh_ajax } from "../src/dbh_ajax";
import { dbh_helper } from "../src/dbh_helper";

export class dbh_custom_validation {

    initClientValidators = () => {

        jqueryValidation.validator.messages.max = jqueryValidation.validator.format("Der Wert darf nicht über {0} liegen.");
        jqueryValidation.validator.messages.min = jqueryValidation.validator.format("Der Wert darf nicht unter {0} liegen.");

        jqueryValidation.validator.addMethod("test",
            function (value, element, parameters) {
                return true;
            }
        );
        jqueryValidationUnobtusive.adapters.addBool("test");

        initRequiredIfValidator();
        initEmailAddressValidator();
        initEmailAddressIfValidator();
        initRangeIfValidator();
        initIsNumberValidator();
        initIsNumberIfValidator();
        initPhoneNumberValidator();
        initPhoneNumberIfValidator();
        initBirthdayValidation();
        initRegexIfValidator();
        initManualInvoiceYearValidation();
        initIsDateRangePlausibleValidation();

        function initRequiredIfValidator() {
            const validatorName: string = "requiredif";
            const attributesPrefix: string = "data-val-requiredif";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    let validationMustBedone = checkRelatedPropertiesForConditionalValidator(element, attributesPrefix);

                    if (validationMustBedone === true) {
                        let isValid = value !== "" && value != null;
                        return isValid;
                    }
                    else {
                        return true;
                    }
                }
            );
            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initEmailAddressValidator() {
            const validatorName: string = "emailaddress";
            const attributesPrefix: string = "data-val-emailaddress";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (
                        value != null && value.length > 0
                    ) {
                        let regex = RegExp($(element).attr(attributesPrefix + "-regex"));

                        let isValid = regex.test(value);

                        return isValid;
                    }
                    else {
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initEmailAddressIfValidator() {
            const validatorName: string = "emailaddressif";
            const attributesPrefix: string = "data-val-emailaddressif";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (
                        value != null && value.length > 0 &&
                        checkRelatedPropertiesForConditionalValidator(element, attributesPrefix)
                    ) {
                        //console.log("emailaddressif validation must be done");
                        let regex = RegExp($(element).attr(attributesPrefix + "-regex"));
                        let isValid = regex.test(value);
                        //console.log("emailaddressif isValid: " + isValid);
                        return isValid;
                    }
                    else {
                        //console.log("emailaddressif validation must not be done");
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initRangeIfValidator() {
            const validatorName: string = "rangeif";
            const attributesPrefix: string = "data-val-rangeif";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (
                        value != null && value.toString() != "" &&
                        checkRelatedPropertiesForConditionalValidator(element, attributesPrefix)
                    ) {
                        //console.log("rangeif validation must be done");
                        let min = $(element).attr(attributesPrefix + "-min");
                        let max = $(element).attr(attributesPrefix + "-max");
                        let isValid = value <= min && value >= max;
                        //console.log("rangeif isValid: " + isValid);
                        return isValid;
                    }
                    else {
                        //console.log("rangeif validation must not be done");
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initIsNumberValidator() {
            const validatorName: string = "isnumber";
            const attributesPrefix: string = "data-val-isnumber";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (value != null && value.toString() != "") {
                        const regex = RegExp($(element).attr(attributesPrefix + "-regex"));
                        let isValid = regex.test(value);
                        const isStep = $(element).attr(`${attributesPrefix}-step`);

                        if (isValid && isStep) {
                            /*Prüfen, wenn Nachkommastellen vorhanden sind, ob diese 25, 5(0), 75 lauten*/
                            if (value.toString().indexOf(",") >= 0) {
                                const afterComma = value.toString().split(',')[1];
                                if (afterComma !== '25' && afterComma !== '5' && afterComma !== '50'
                                    && afterComma !== '75' && afterComma !== '00' && afterComma !== '0') {
                                    isValid = false;
                                }
                            }
                        }

                        return isValid;
                    }
                    else {
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initIsNumberIfValidator() {
            const validatorName: string = "isnumberif";
            const attributesPrefix: string = "data-val-isnumberif";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    //console.log("element:");
                    //console.log(element);
                    //console.log("parameters:");
                    //console.log(parameters);
                    //console.log("value:");
                    //console.log(value);
                    //console.log(value.length);

                    if (
                        value != null && value.toString() != "" &&
                        checkRelatedPropertiesForConditionalValidator(element, attributesPrefix)
                    ) {
                        //console.log("rangeif validation must be done");
                        let regex = RegExp($(element).attr(attributesPrefix + "-regex"));
                        let isValid = regex.test(value);
                        //console.log("rangeif isValid: " + isValid);
                        return isValid;
                    }
                    else {
                        //console.log("rangeif validation must not be done");
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initPhoneNumberValidator() {
            const validatorName: string = "phonenumber";
            const attributePrefix: string = "data-val-phonenumber";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (value != null && value.length > 0) {
                        //console.log("emailaddressif validation must be done");
                        let regex = RegExp($(element).attr(attributePrefix + "-regex"));
                        let isValid = regex.test(value);
                        //console.log("emailaddressif isValid: " + isValid);
                        return isValid;
                    }
                    else {
                        //console.log("emailaddressif validation must not be done");
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initPhoneNumberIfValidator() {
            const validatorName: string = "phonenumberif";
            const attributePrefix: string = "data-val-phonenumberif";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (
                        value != null && value.length > 0 &&
                        checkRelatedPropertiesForConditionalValidator(element, attributePrefix)
                    ) {
                        //console.log("emailaddressif validation must be done");
                        let regex = RegExp($(element).attr(attributePrefix + "-regex"));
                        let isValid = regex.test(value);
                        //console.log("emailaddressif isValid: " + isValid);
                        return isValid;
                    }
                    else {
                        //console.log("emailaddressif validation must not be done");
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initRegexIfValidator() {
            const validatorName: string = "regexif";
            const attributePrefix: string = "data-val-regexif";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (
                        value != null && value.length > 0 &&
                        checkRelatedPropertiesForConditionalValidator(element, attributePrefix)
                    ) {
                        //console.log("emailaddressif validation must be done");
                        let regex = RegExp($(element).attr(attributePrefix + "-regex"));
                        let isValid = regex.test(value);
                        //console.log("emailaddressif isValid: " + isValid);
                        return isValid;
                    }
                    else {
                        //console.log("emailaddressif validation must not be done");
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initManualInvoiceYearValidation() {
            const validatorName: string = "rangeManualInvoiceYear";
            const minAttributePrefix: string = "data-val-rangemanualinvoiceyear-mindate";
            const maxAttributePrefix: string = "data-val-rangemanualinvoiceyear-maxdate";


            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (value != null && value.length > 0) {
                        if (value.toString().indexOf(".") > 0) {
                            const arr = value.split(".");
                            if (arr.length !== 3) {
                                return false;
                            }
                            value = `${arr[2]}-${arr[1]}-${arr[0]}`;
                        }

                        let minDateVal = $(element).attr(minAttributePrefix);
                        let minDate = new Date(minDateVal);
                        minDate.setHours(0, 0, 0, 0);

                        let maxDateVal = $(element).attr(maxAttributePrefix);
                        let maxDate = new Date(maxDateVal);
                        maxDate.setHours(0, 0, 0, 0);

                        let curDate = new Date(value);
                        curDate.setHours(0, 0, 0, 0);

                        //console.log("minDate: ", new Date(minDateVal))
                        //console.log("raw: ", value);
                        //console.log("curDate: ", new Date(value));

                        return minDate <= curDate && curDate <= maxDate;
                    }
                    else {
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initBirthdayValidation() {
            const validatorName: string = "isvalidbirthday";
            const attributePrefix: string = "data-val-isvalidbirthday-minbirthdate";

            jqueryValidation.validator.addMethod(validatorName,
                function (value, element, parameters) {
                    if (value != null && value.length > 0) {

                        if (value.toString().indexOf(".") > 0) {
                            const arr = value.split(".");
                            if (arr.length !== 3) {
                                return false;
                            }
                            value = `${arr[2]}-${arr[1]}-${arr[0]}`;
                        }

                        let minDateVal = $(element).attr(attributePrefix);
                        let minDate = new Date(minDateVal);
                        minDate.setHours(0, 0, 0, 0);

                        let maxDate = new Date();
                        maxDate.setHours(0, 0, 0, 0);

                        let curDate = new Date(value);
                        curDate.setHours(0, 0, 0, 0);

                        //console.log("minDate: ", minDate)
                        //console.log("maxDate: ", maxDate)
                        //console.log("curDate: ", curDate)


                        //console.log("curDate: ", new Date(value));

                        return minDate <= curDate && curDate <= maxDate;
                    }
                    else {
                        return true;
                    }
                }
            );

            jqueryValidationUnobtusive.adapters.addBool(validatorName);
        }

        function initIsDateRangePlausibleValidation() {            
            if (jqueryValidation.validator.methods.isdaterangeplausible) return;

            var lastElement = null;
            var lastValue = null;
            var lastValidValue = false;

            jqueryValidation.validator.addMethod('isdaterangeplausible', function (value, element, params) {
                var isValid = false;

                // Da die DateTime-Felder sich für die Formatierung selbst umschalten (Formate), wird diese Validierung sehr oft aufgerufen
                if (lastElement != element || lastValue != value) {
                    lastElement = element;
                    lastValue = value;

                    $.ajax({
                        url: "/Home/IsDateRangePlausibleValidation",
                        data: {
                            "value": $(element).val().toString(),
                            "propertyToCompare": $('[name="' + $(element).attr("data-val-isdaterangeplausible-datetocheck").toString() + '"]').val().toString(),
                            "isGreaterThen": $(element).attr("data-val-isdaterangeplausible-type").toString()
                        },
                        async: false, // wichtig, damit erst nacher der Server Validierung isValid ausgewertet wird
                        success: function (msg) {
                            isValid = msg;
                        }
                    });
                    lastValidValue = isValid;
                    return isValid;
                }
                else {
                    return lastValidValue;
                }

            });

            jqueryValidationUnobtusive.adapters.add('isdaterangeplausible', [], function (options) {
                options.rules['isdaterangeplausible'] = {};
                options.messages['isdaterangeplausible'] = options.message;
            });
        }

        function checkRelatedPropertiesForConditionalValidator(element, validatorAttributesPrefix) {
            const prop1NameAttributeName: string = validatorAttributesPrefix + "-prop1-name";
            const prop1ValueAttributeName: string = validatorAttributesPrefix + "-prop1-value";
            const prop2NameAttributeName: string = validatorAttributesPrefix + "-prop2-name";
            const prop2ValueAttributeName: string = validatorAttributesPrefix + "-prop2-value";
            return checkRelatedPropertiesFromAttributes(element, prop1NameAttributeName, prop1ValueAttributeName, prop2NameAttributeName, prop2ValueAttributeName);
        }

        function checkRelatedPropertiesFromAttributes(element, prop1NameAttributeName, prop1ValueAttributeName, prop2NameAttributeName, prop2ValueAttributeName) {
            //console.log("element");
            //console.log(element);
            let prop1Name = element.getAttribute(prop1NameAttributeName);
            let prop1ValueExpected = element.getAttribute(prop1ValueAttributeName);
            let prop2Name = element.getAttribute(prop2NameAttributeName);
            let prop2ValueExpected = element.getAttribute(prop2ValueAttributeName);

            //console.log("prop1Name: " + prop1Name);
            //console.log("prop1ValueExpected: " + prop1ValueExpected);
            //console.log("prop2Name: " + prop2Name);
            //console.log("prop2ValueExpected: " + prop2ValueExpected);

            let validationMustBeDone = false;
            if (prop1Name != null && prop1Name.length > 0 && prop1ValueExpected != null && prop1ValueExpected.length > 0) {
                let $prop1 = $("[name='" + prop1Name + "']");

                if ($prop1.length === 0) {
                    /* Element mit dem "name"-Attribute nicht gefunden. Prüfen, 
                     * ob es eine Property eines Objects ist, welches zu einer 
                     * Liste gehört (z.B. bei "BetreuerBelegungenVeraenderungPopupViewModel" 
                     * in "BelegungBeendenModel")*/

                    const nameOfElement = element.getAttribute("name");
                    const nameContainsNumber = /\d/.test(nameOfElement);
                    // Listenelemente haben im Namen den zugehörigen Index (z.B. "Betreuer_Belegungen[0].StundenString")
                    if (nameContainsNumber && nameOfElement.length > 0) {
                        const realPropName = `${nameOfElement.toString().split(".")[0]}.${prop1Name}`;
                        //console.log(realPropName);
                        $prop1 = $("[name='" + realPropName + "']");
                    }
                    //console.log("nameOfElement: ", nameOfElement);
                    //console.log("prop1Name: " + prop1Name);
                }

                //console.log($prop1);

                let prop1Value;
                if ($prop1.is(":radio") || $prop1.is(":checkbox")) {
                    prop1Value = $prop1.filter(":checked").val();
                }
                else {
                    prop1Value = $prop1.val();
                }
                //console.log("prop1:");
                //console.log(prop1Value + " - " + prop1ValueExpected);

                if (("" + prop1Value).toLowerCase() === ("" + prop1ValueExpected).toLowerCase()) {
                    if (prop2Name != null && prop2Name.length > 0 && prop2ValueExpected != null && prop2ValueExpected.length > 0) {
                        let $prop2 = $("[name='" + prop2Name + "']");
                        let prop2Value;
                        if ($prop2.is(":radio")) {
                            prop2Value = $prop2.filter(":checked").val();
                        }
                        else {
                            prop2Value = $prop2.val();
                        }
                        //console.log("prop2:");
                        //console.log(prop2Value + " - " + prop2ValueExpected);
                        if (("" + prop2Value).toLowerCase() === ("" + prop2ValueExpected).toLowerCase()) {
                            validationMustBeDone = true;
                        }
                        else {
                            validationMustBeDone = false;
                        }
                    }
                    else {
                        /* Zweiter Vergleich ist optional. Wenn Attribute nicht angegeben sind, dann sind sie für requiredif nicht relevant. */
                        validationMustBeDone = true;
                    }
                }
                else {
                    validationMustBeDone = false;
                }
            }
            return validationMustBeDone;
        }
    };

    reInitialiseValidation = () => {
        $("form").removeData("validator");
        $("form").removeData("unobtrusiveValidation");
        //@ts-ignore
        $.validator.unobtrusive.parse("form");
        this.initClientValidators();
    };

    validateForm = (containerSelector) => {
        let formIsValid = true;
        let $container = $(containerSelector);
        let $formFieldsToValidate = $container.find("[data-val=true]");
        //console.log($formFieldsToValidate),
        $formFieldsToValidate.each(function (index) {
            let $formField = $(this);
            //console.log($formField);
            let fieldIsValid = ($formField as any).valid();
            /*jquery-Validation validiert die Min- /Max-Werte bei input[type=date] nicht. Diese müssen manuel geprüft werden*/
            if (fieldIsValid && $formField.attr('class') && $formField.attr('class').toLowerCase().indexOf('form-text-datepicker') >= 0 && ($formField.attr('min') || $formField.attr('max'))) {
                let formValueString = $formField.val().toString();
                if (formValueString.indexOf('.') >= 0) {
                    const formValueArr = formValueString.split('.');
                    formValueString = `${formValueArr[2]}-${formValueArr[1]}-${formValueArr[0]}`;
                }

                const valueAsDate: Date = new Date(formValueString);

                const minDate: Date = $formField.attr('min') ? new Date($formField.attr('min')) : undefined;
                const maxDate: Date = $formField.attr('max') ? new Date($formField.attr('max')) : undefined;

                let dateRangeIsValid = true;
                if (minDate) {
                    dateRangeIsValid = minDate <= valueAsDate;
                }

                if (maxDate && dateRangeIsValid) {
                    dateRangeIsValid = maxDate >= valueAsDate;
                }

                fieldIsValid = dateRangeIsValid;
                if (!fieldIsValid) {

                    const $form = $formField.closest("form");
                    const fieldname = $formField.prop("name");
                    if ($form.length > 0 && fieldname) {
                        //($formField).addClass("input-validation-error");
                        //@ts-ignore
                        //let $validator = $form.validate()
                        //let error = { fieldname: "Hier Error" };
                        //$validator.showErrors(error);
                    }
                }
            }

            formIsValid = formIsValid && fieldIsValid;

            //console.log("[name='" + $formField.attr("name") + "'] is " + fieldIsValid);
        });

        return formIsValid;
    };
};
